import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, ChevronDown } from "lucide-react";
import DrawerMegaMenu from "src/components/ui-elements/DrawerMegaMenu";

const NavDrawer = ({ isOpen, onClose, menuItems }) => {
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
  const submenuRef = useRef(null);

  const handleToggleSubMenu = (index) => {
    setOpenSubMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // Scroll to make the expanded submenu visible when it opens
  useEffect(() => {
    if (openSubMenuIndex !== null && submenuRef.current) {
      // Add a small delay to allow the submenu to render
      setTimeout(() => {
        submenuRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  }, [openSubMenuIndex]);

  return (
    <>
      <div
        className={`font-outfitMedium fixed inset-0 bg-black bg-opacity-50 z-20 transition-opacity ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={onClose}
      ></div>
      <div
        className={`fixed top-0 left-0 h-full w-72 md:w-xl shadow-lg z-30 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out flex flex-col`}
        style={{ backgroundColor: 'var(--navbar-mobile-bg)' }}
      >
        {/* Drawer Header */}
        <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: 'var(--navbar-mobile-text)' }}>
          <h2 className="text-lg font-outfitBold" style={{ color: 'var(--navbar-mobile-text)' }}>Menu</h2>
          <button
            onClick={onClose}
            style={{ color: 'var(--navbar-mobile-text)' }}
          >
            <X size={24} />
          </button>
        </div>
        <div className="overflow-y-auto flex-1">
          <ul className="p-4 space-y-4 font-outfitMedium">
            {menuItems.map((item, index) => (
              <li 
                key={index} 
                className="relative group"
                ref={openSubMenuIndex === index ? submenuRef : null}
              >
                <div
                  className="flex items-center justify-between"
                  onClick={() => handleToggleSubMenu(index)}
                >
                  <Link
                    to={item.link}
                    className="block text-lg transition duration-300 relative font-outfitMedium"
                    style={{ color: 'var(--navbar-mobile-text)' }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--navbar-mobile-hover)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--navbar-mobile-text)'}
                    onClick={onClose}
                  >
                    {item.name}
                  </Link>
                  {item.subMenu && (
                    <ChevronDown
                      size={16}
                      className={`ml-2 transition-transform ${
                        openSubMenuIndex === index ? 'transform rotate-180' : ''
                      }`}
                      style={{ color: 'var(--navbar-mobile-text)' }}
                      onMouseEnter={(e) => e.currentTarget.style.color = 'var(--navbar-mobile-hover)'}
                      onMouseLeave={(e) => e.currentTarget.style.color = 'var(--navbar-mobile-text)'}
                    />
                  )}
                </div>
                {/* Submenu */}
                {item.subMenu && openSubMenuIndex === index && (
                  <DrawerMegaMenu menuItem={item} closeMenu={onClose} />
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default NavDrawer;
